import React from 'react';
import Register from '@components/Auth/Register';
import { NavLink } from 'react-router-dom';
import { routes } from '@routes';
import { useSession } from '@hooks';

type RegisterPageProps = {
    //
};

const languagesVarsCodes = [
    "LANG_neobooking_auth_register", //S'inscrire
    "LANG_neobooking_auth_register_intro", //Inscrivez-vous pour gérer vos reservations
    "LANG_neobooking_auth_login_now", //connectez-vous
    "LANG_neobooking_or", //ou
]

const RegisterPage: React.FC<RegisterPageProps> = () => {

    const { getLanguageVarValue } = useSession()

    return <>
        <div className='tw-container sm:tw-mx-auto sm:tw-w-full sm:tw-max-w-2xl'>
            <h1 className="title">{getLanguageVarValue("LANG_neobooking_auth_register")}</h1>
            <p>{getLanguageVarValue("LANG_neobooking_auth_register_intro")}
                <br /> {getLanguageVarValue("LANG_neobooking_or")} {" "}
                <NavLink to={routes.login} className="focus:tw-outline-none tw-cursor-pointer tw-text-primary-500 hover:tw-text-primary-400 tw-transition-colors tw-duration-200 tw-ease-in-out">
                    {getLanguageVarValue("LANG_neobooking_auth_login_now")} !
                </NavLink>
            </p>
            <Register />
        </div>
    </>
}

export default RegisterPage